import React from 'react';
import PropTypes from 'prop-types';
import { Row } from 'react-bootstrap';
import { useIntl } from 'react-intl';

import { SUBSCRIPTION_STATUS_MAP } from 'app/modules/MyAccount/pages/PaymentMethods/utils';
import Notification from 'app/components/Notification';
import Button from 'app/components/Button';
import Icon from 'app/components/Icon';
import { Colors } from 'app/utils/colors';
import CreditCardsDetail from 'app/modules/MyAccount/pages/PaymentMethods/components/CreditCards/CreditCardsDetail';

export default function ActiveSubscriptions({
  hasNextExpirationSubscriptions,
  userSubscriptions
}) {
  const intl = useIntl();

  return (
    <>
      {hasNextExpirationSubscriptions && (
        <Notification
          header={intl.formatMessage({
            id: 'controlpanel.payment_methods.subscription.notification.next_expired.title'
          })}
          content={intl.formatMessage({
            id: 'controlpanel.payment_methods.subscription.notification.next_expired.subtitle'
          })}
          variant="alert"
          button={null}
        />
      )}
      <Row className="bb-payment-methods-bigbuy-page__content__subscriptions__row-info">
        {userSubscriptions.map(({ id, attributes }) => (
          <React.Fragment key={id}>
            <CreditCardsDetail
              id={id}
              {...attributes}
              showActions={false}
              nextExpiration={
                attributes.status === SUBSCRIPTION_STATUS_MAP.NEXT_EXPIRATION
              }
            />
            <Button
              onClick={() => {
                window.location.href = attributes.url;
              }}
              text={intl.formatMessage({
                id: 'controlpanel.payment_methods.subscription.manage.button'
              })}
              size="big"
              type="secondary"
              iconRight={
                <Icon
                  icon="arrow-up-right-from-square"
                  size="lg"
                  swapOpacity
                  color={Colors.bbWhite}
                />
              }
            />
          </React.Fragment>
        ))}
      </Row>
    </>
  );
}

ActiveSubscriptions.propTypes = {
  hasNextExpirationSubscriptions: PropTypes.bool.isRequired,
  userSubscriptions: PropTypes.arrayOf(PropTypes.node).isRequired
};
